import React, { memo, useEffect } from "react"
import ArbolEmpresa from "./treeOrganigrama.jsx"
import {removejscssfile} from '../../Util/Util.jsx';


 function arbolEmpresa(props) {

const scriptJavaActualizar=()=>{

    //console.log('scriptJavaActualizar');
        //  removejscssfile("MultiNestedList", "js") //remove all occurences of "somescript.js" on page
        //  removejscssfile("perfect-scrollbar.js", "js")
        // // //         //Se metido el script por que cuando es asincronico la consulta a base de datos y el llenedo se hace despues de montado el react, la funcionalidad del java script saparece

        //  let script = document.createElement("script");
        //  script.src = "/Public/lib/utilitarios/MultiNestedList.js";
        //  script.async = false;      
        //  document.body.appendChild(script);

        //  let scriptTree = document.createElement("script");
        //  scriptTree.src="/Public/lib/perfect-scrollbar/perfect-scrollbar.js";
        //  scriptTree.async =true;
        //  document.body.appendChild(scriptTree);    
};


useEffect(scriptJavaActualizar,[]);

  return (
                <ArbolEmpresa
                    lstOrganigrama={props.lstOrganigrama}
                    handlerArbol={props.handlerArbol}
                    displayOrg ={props.displayOrg}
                    boton={props.boton}
                    NodosAbiertos={props.NodosAbiertos}
                 />
  );
};
export default memo(arbolEmpresa);